<template>
  <transition name="loading">
    <div v-if="showLoading" class="loading-module">
      <img :src="moduleData.img_url" alt="">
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    moduleData: {
      type: Object
    },
    showLoading: {
      type: Boolean
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.loading-enter,.loading-leave-to{
  opacity: 0;
}
.loading-enter-to,.loading-leave{
  opacity: 1;
}
.loading-enter-active,.loading-leave-active{
  transition: all 1s;
}
.loading-module {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 101;
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/loading.vue